import { Box, Grid, useTheme } from '@mui/material';
import {
  Icon48SocialMediaFilledFacebook,
  Icon48SocialMediaFilledX,
  Icon48SocialMediaFilledYoutube,
  Icon48SocialMediaFilledInstagram,
} from '@care/react-icons';
import {
  Icon48FacebookFilled,
  Icon48XFilled,
  Icon48YouTubeFilled,
  Icon48InstagramFilled,
} from '@care/react-embrace-icons';
import useTestFlags from '@/components/hooks/useTestFlags';
import { SOCIAL_LINKS } from '@/constants';
import { SxClassProps } from '@/types';
import { handleSocialIconsClick } from './commonFooterBlocks';

const classes: SxClassProps = {
  socialContainer: {
    justifyContent: 'center',
    '@media (min-width: 960px)': {
      justifyContent: 'flex-end',
    },
  },
  icon: (theme) => ({
    margin: theme.spacing(0, 0, 0, 3),
  }),
};

// eslint-disable-next-line import/prefer-default-export
export const SocialLinksShared = () => {
  const theme = useTheme();
  const { greaterCare } = useTestFlags();
  const isGreaterCare = greaterCare?.value === 1;
  const IconFilledFacebook = isGreaterCare ? Icon48FacebookFilled : Icon48SocialMediaFilledFacebook;
  const IconFilledX = isGreaterCare ? Icon48XFilled : Icon48SocialMediaFilledX;
  const IconFilledYoutube = isGreaterCare ? Icon48YouTubeFilled : Icon48SocialMediaFilledYoutube;
  const IconFilledInstagram = isGreaterCare
    ? Icon48InstagramFilled
    : Icon48SocialMediaFilledInstagram;

  return (
    <Grid container sx={classes.socialContainer}>
      <Box
        component="a"
        href={`${SOCIAL_LINKS.facebook}`}
        data-testid="facebook"
        sx={classes.icon}
        onClick={(e) => handleSocialIconsClick(e, 'Facebook', SOCIAL_LINKS.facebook)}>
        <IconFilledFacebook
          size="48px"
          sx={{
            color: isGreaterCare ? theme.palette.icon.brandInverse : theme.palette.icon.primary,
            '& path': {
              fill: isGreaterCare ? theme.palette.icon.brand : theme.palette.care.grey[50],
            },
          }}
        />
      </Box>
      <Box
        component="a"
        href={`${SOCIAL_LINKS.twitter}`}
        data-testid="twitter"
        sx={classes.icon}
        onClick={(e) => handleSocialIconsClick(e, 'Twitter', SOCIAL_LINKS.twitter)}>
        <IconFilledX
          size="48px"
          sx={{
            color: isGreaterCare ? theme.palette.icon.brandInverse : theme.palette.icon.primary,
            '& path': {
              fill: isGreaterCare ? theme.palette.icon.brand : theme.palette.care.grey[50],
            },
          }}
        />
      </Box>
      <Box
        component="a"
        href={`${SOCIAL_LINKS.youtube}`}
        data-testid="youtube"
        sx={classes.icon}
        onClick={(e) => handleSocialIconsClick(e, 'Youtube', SOCIAL_LINKS.youtube)}>
        <IconFilledYoutube
          size="48px"
          sx={{
            color: isGreaterCare ? theme.palette.icon.brandInverse : theme.palette.icon.primary,
            '& path': {
              fill: isGreaterCare ? theme.palette.icon.brand : theme.palette.care.grey[50],
            },
          }}
        />
      </Box>
      <Box
        component="a"
        href={`${SOCIAL_LINKS.instagram}`}
        data-testid="instagram"
        sx={classes.icon}
        onClick={(e) => handleSocialIconsClick(e, 'Instagram', SOCIAL_LINKS.instagram)}>
        <IconFilledInstagram
          size="48px"
          sx={{
            color: isGreaterCare ? theme.palette.icon.brandInverse : theme.palette.icon.primary,
            '& path': {
              fill: isGreaterCare ? theme.palette.icon.brand : theme.palette.care.grey[50],
            },
          }}
        />
      </Box>
    </Grid>
  );
};
